import { Component, OnInit } from '@angular/core';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { SharedService } from 'src/app/services/sharedService';
import { InformationDialogComponent } from '../../dialogs/information-dialog/information-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MapService } from '../../map/map.service';

@Component({
  selector: 'app-boundary-configuration',
  templateUrl: './boundary-configuration.component.html',
  styleUrls: ['./boundary-configuration.component.css']
})
export class BoundaryConfigurationComponent implements OnInit {
  municipalityChangeSubscription: any
  buildingId
  selectedBuildingDetails
  bbox
  locationLatLng
  boundaries
  selectedFilter
  childLayer = {}
  currentLayer
  workingLayer
  municipalityId
  districtId

  constructor(public sharedService: SharedService, public propertyTaxService: PropertyTaxService,
    public mapService: MapService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.currentLayer = this.sharedService.getLayer('municipality')
    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(val => {
      this.bbox = val && val['bbox'] || undefined
      if (this.bbox !== undefined) {
        localStorage.setItem('municipalityBbox', this.bbox)
      }
    })
  }

  setBBox(val) {
    if (localStorage.getItem('municipalityBbox'))
      this.bbox = localStorage.getItem('municipalityBbox')
  }

  setBoundaries(boundaries) {
    this.boundaries = boundaries
  }
  chDropdown(ev) {
    this.selectedFilter = ev
    if (this.selectedFilter.coordinates)
      this.boundaries = this.selectedFilter.coordinates
    else this.boundaries = null
    this.workingLayer = this.selectedFilter.field.toLowerCase();
    this.setParentIds(this.workingLayer)

    if (this.workingLayer==='municipality'){
      this.currentLayer = this.sharedService.getLayer(this.workingLayer)
    }
    this.childLayer = this.getChildLayer(this.workingLayer)
  }

  setParentIds(layer){
    if (layer === 'municipality'){
        this.municipalityId = this.selectedFilter.value.id
    }
    if (layer === 'district'){
      this.districtId = this.selectedFilter.value.id
    }
  }
  async applyBoundary() {
    const val = this.selectedFilter.value
    let featureBody = {key : val.name, attributes: {id:val.id}, geoJson:this.boundaries}
    if (this.selectedFilter.field==='DISTRICT'){
      featureBody.attributes['parentId'] = this.municipalityId
    }
    if (this.selectedFilter.field==='ILOT'){
      featureBody.attributes['parentId'] = this.districtId
    }
    const boundaryOld = await this.propertyTaxService.getBoundary(val.id).toPromise()
    featureBody['id'] = this.selectedBuildingDetails?.id || boundaryOld?.coordinates?.id
    let mapData = await this.mapService.upsertFeature$(featureBody, this.sharedService.getLayer(this.workingLayer)).toPromise()
    this.boundaries['id'] = mapData.data.id
    const boundary = {
      coordinates: this.boundaries, field: this.selectedFilter.field, id: this.selectedFilter.id, value: {
        name: val.name, id: val.id
      }
    }
    await this.propertyTaxService.setBoundary(boundary).toPromise()
    this.dialog.open(InformationDialogComponent, {
      width: "500px",
      disableClose: true,
      data: { text: "DIALOG.BOUNDARY_SET" },
    });
  }

  async deleteBoundary() {
    const val = this.selectedFilter.value
    // Workaround for JSON not to set {} or null
    const boundary = {
      coordinates: {id: null, bbox: null, coordinates: []}, field: this.selectedFilter.field, id: this.selectedFilter.id, value: {
        name: val.name, id: val.id
      }
    }
    const boundaryOld = await this.propertyTaxService.getBoundary(val.id).toPromise()
    await this.propertyTaxService.setBoundary(boundary).toPromise()
    const featureId = this.selectedBuildingDetails?.id || boundaryOld?.coordinates?.id
    if (featureId)
      await this.mapService.deleteFeature$(featureId).toPromise()
    this.dialog.open(InformationDialogComponent,{
      width: "500px",
      disableClose: true,
      data: { text: "DIALOG.BOUNDARY_DELETE"},
    });
    this.sharedService.deleteBoundaries()
  }

  selectPolygon(event){
    this.selectedBuildingDetails = event
    this.sharedService.selectPolygon(this.selectedBuildingDetails)
  }


  getChildLayer(layer){
    switch (layer) {
      case 'municipality':
          return {layer: this.sharedService.getLayer('district'), parentId: this.selectedFilter.value.id}
        case 'district':
          return {layer: this.sharedService.getLayer('ilot'), parentId: this.selectedFilter.value.id}
      default:
        return null
    }
  }

}
